import axios from 'axios';

export function registeredAgentAccount(account) {
    const bankCd = account?.bank_cd;
    const bankName = account?.bank_nm || account?.bank_name;
    const number = account?.accnt_no || account?.account_number;
    if (!bankCd || !bankName || !number) return null;
    return { bankCd, bankName, account: number, accountName: account.accnt_nm || account.accnt_holder || account.account_holder };
}

export async function lookupAgentAccountHolder(recipient) {
    try {
        const response = await axios.post(process.env.REACT_APP_API + '/api/agent-wallet/account-holder', {
            bank_cd: recipient.bankCd, accnt_no: recipient.account,
        }, { withCredentials: true });
        return response.data;
    } catch (error) {
        return error.response?.data ?? { msg: '예금주 조회에 실패했습니다. 다시 조회해주세요.' };
    }
}

export async function transferAgentWallet(body, csrf) {
    try {
        if(body.authorization && (typeof csrf!=='string'||!csrf.trim()))throw new Error('송금 보안 토큰이 없습니다.');
        const config={withCredentials:true};
        if(body.authorization)config.headers={'Content-Type':'application/json','X-CSRF-Token':csrf};
        const response = await axios.post(process.env.REACT_APP_API + '/api/agent-wallet/withdraw', body, config);
        const result = response.data;
        return { ok: result?.code === 1000, code: result?.code, msg: result?.msg };
    } catch (error) {
        return { ok: false, code: error.response?.data?.code, msg: error.response?.data?.msg ?? '송금 처리 결과를 확인하지 못했습니다. 같은 요청의 결과를 다시 확인해주세요.' };
    }
}

// Never use /withdrawals?request_id: that history route does not filter by request ID.
export async function queryAgentRequest({ request_id }) {
    let result;
    try {
        result = (await axios.get(process.env.REACT_APP_API + '/api/agent-wallet/requests/' + encodeURIComponent(request_id), { withCredentials: true })).data;
    } catch (error) {
        if (error.response?.data?.code !== 4040) throw error;
        result = error.response.data;
    }
    if (result?.code === 4040) return { code: 1000, data: { requests: [] } };
    return { code: 1000, data: { requests: [result] } };
}
export async function listUnresolvedAgentRequests() {
    return (await axios.get(process.env.REACT_APP_API + '/api/agent-wallet/requests', {
        withCredentials: true, params: { status: 'unresolved', page: 1, limit: 100 },
    })).data;
}
